import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { LaasOption } from 'src/app/core/models/laas-option';
import { PageInfo } from 'src/app/core/models/page-info';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { deepCopy, getBrandByPermission, getCustomerByPermission, getDataScopeByPermission, getDeptByPermission, getOrgIdByPermission, getTenantByPermission, isNullOrEmpty, laaSFormatString } from 'src/app/core/utils/common-functions';
import { UserService as UserDataService } from 'src/app/features/user/services/user-service.service';
import { DataTableSavedBean } from 'src/app/shared/components/data-table/bean/data-table-saved-bean';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserGroupSubscriptionData } from '../../interface/user-group-subscription-data';
import { UserGroupSubscriptionMaintenanceService } from '../../service/user-group-subscription-maintenance.service';
import { TenantMappingUserGroupDetailDialogComponent } from '../tenant-mapping-user-group-detail-dialog/tenant-mapping-user-group-detail-dialog.component';
import * as xlsx from 'xlsx';
import * as _ from 'lodash';
import { pipe, groupBy, map } from 'lodash/fp';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { filter } from 'rxjs';
@Component({
  selector: 'laas-user-group-subscription-maintenance',
  templateUrl: './user-group-subscription-maintenance.component.html',
  styleUrls: ['./user-group-subscription-maintenance.component.scss']
})
export class UserGroupSubscriptionMaintenanceComponent extends SessionBaseComponent implements OnInit {

  isSearchFormOpen: boolean = true;
  searchForm: FormGroup;
  searchParams: any;
  notifyEventOptions: any[] = [];
  notifyEventOptionsBySelectedWorkType: any[] = [];
  userGroupOptions: any[] = [];
  userGroupOptionsByPermission: any[] = [];
  searchFormUserGroupOptionsBySelectedTenant: any[] = [];
  userGroupOptionsBySelectedTenant: any[] = [];
  tenantOptions: any[] = [];
  tenantOptionsByPermission: any[] = [];
  searchFormTenantOptionsBySelectedGroup: any[] = [];
  tenantOptionsBySelectedGroup: any[] = [];
  orgIdOptions: any[] = [];
  orgIdOptionsByPermission: any[] = [];
  orgIdOptionsBySelectedTenant: any[] = [];
  workTypeOptions: any[] = [];
  searchFormWorkTypeOptionsBySelectedNotifyEvent: any[] = [];
  workTypeOptionsBySelectedNotifyEvent: any[] = [];
  brandOptions: LaasOption[] = [];
  brandAndVendorCategoryOptions: any[] = [];
  vendorCategoryOptions: any[] = [];
  vendorCategoryOptionsBySelectedBrand: any[] = [];
  deptOptions: any[] = [];
  deptOptionsByPermission: any[] = [];
  customerOptions: LaasOption[] = [];
  customerOptionsByPermission: LaasOption[] = [];
  salesOptions: LaasOption[] = [];
  userOptions: LaasOption[] = [];

  isShowTenantMappingUserGroupDetail: boolean = false;

  selectedRows: any;
  previousSelectedRow: any;
  userGroupSubscriptionData: UserGroupSubscriptionData[] = [];
  userGroupSubscriptionColumns: any[] = [];
  backupUserGroupSubscriptionData: UserGroupSubscriptionData[] = [];
  isLoading: boolean = false;
  editPermission: boolean = false;
  isInEditMode: boolean = false;

  // Table paging info
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "SeqNo",
    direction: -1
  };

  first: number = 0;

  preferenceKey: string = UserPreferenceConstants.UserGroupSubscriptionTableData;

  permissionCode: PermissionConstants = PermissionConstants.ViewUserGroupSubscription;
  readonly helpCenterPermissionCode: PermissionConstants = PermissionConstants.ViewUserGroupSubscription;
  readonly editPermissionCode: PermissionConstants = PermissionConstants.EditUserGroupSubscription;
  currentLang: string = this.laasSetting.language;
  private transformDataPipe = pipe(
    map((item: any) => {
      const userGroup = this.userGroupOptionsByPermission.find(x => x.groupCode === item.groupCode);
      const seqNo = isNaN(item.seqNo) ? null : Number(item.seqNo);
      return {
        ...item,
        seqNo,
        updateActivatedDt: item.updateActivatedDt ? new Date(item.updateActivatedDt).getTime() : null,
        createDt: item.createDt ? new Date(item.createDt).getTime() : null,
        updateDt: item.updateDt ? new Date(item.updateDt).getTime() : null,
        tenantMappingUserGroupSeqNo: userGroup ? userGroup.seqNo : null
      };
    }),
    groupBy((item: any) => {
      return `${item.seqNo}${item.notifyEventGroupKey}${item.tenantMappingUserGroupSeqNo}${item.tenant}${item.orgId}${item.workType}`;
    }),
    map((items: any[]) => {
      const {
        seqNo,
        notifyEventGroupKey,
        tenantMappingUserGroupSeqNo,
        groupCode,
        tenant,
        orgId,
        workType,
        isActivated,
        updateActivatedUser,
        updateActivatedDt,
        createUser,
        createDt,
        updateUser,
        updateDt
      } = items[0];
      const brands = _.uniq(items.map(i => i.brand).flat()).filter((v) => v);
      const vendorCategories = _.uniq(items.map(i => i.vendorCategory).flat()).filter((v) => v);
      const depts = _.uniq(items.map(i => i.dept).flat()).filter((v) => v);
      const consigneeKeys = _.uniq(items.map(i => i.consigneeKey).flat()).filter((v) => v);
      const salesCodes = _.uniq(items.map(i => i.salesCode).flat()).filter((v) => v);
      const val = String(isActivated).toLowerCase();
      const dealIsActivated = ['1', 'y'].includes(val) ? 1 : 0;
      const orgIdAllowList = this.filterOrgOptions(tenant);
      const dealOrgId = orgIdAllowList && orgIdAllowList.length > 0 && orgIdAllowList.findIndex((option: any) => option.value === orgId) > -1 ? orgId : null;
      return {
        seqNo,
        notifyEventGroupKey,
        tenantMappingUserGroupSeqNo,
        groupCode,
        tenant,
        orgId: dealOrgId,
        workType,
        isActivated: dealIsActivated,
        transIsActivated: (dealIsActivated === 1),
        updateActivatedUser: seqNo ? updateActivatedUser : null,
        updateActivatedDt: seqNo ? updateActivatedDt : null,
        createUser: seqNo ? createUser : null,
        createDt: seqNo ? createDt : null,
        updateUser: seqNo ? updateUser : null,
        updateDt: seqNo ? updateDt : null,
        brand: (brands.length && !brands.includes('ALL')) ? brands : null,
        vendorCategory: (vendorCategories.length && !vendorCategories.includes('ALL')) ? vendorCategories : null,
        dept: (depts.length && !depts.includes('ALL')) ? depts : null,
        consigneeKey: (consigneeKeys.length && !consigneeKeys.includes('ALL')) ? consigneeKeys : null,
        salesCode: (salesCodes.length && !salesCodes.includes('ALL')) ? salesCodes : null,
      };
    })
  );

  @ViewChild('headerTable') dataTable!: DataTableComponent;
  @ViewChild('tenantMappingUserGroupDetailDialog') tenantMappingUserGroupDetailDialog!: TenantMappingUserGroupDetailDialogComponent;

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private notificationSubScriptionService: NotificationSubScriptionService,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private userDataService: UserDataService,
    private dropdownOptionService: DropdownOptionsService,
    private userGroupSubscriptionMaintenanceService: UserGroupSubscriptionMaintenanceService,
    private dOService: DeliveryOrderService,
    private datePipe: DatePipe
  ) {
    super(injector);

    this.searchForm = this.formBuilder.group({
      notifyEventGroupKey: null,
      tenant: null,
      tenantMappingUserGroupSeqNo: null,
      workType: null,
      brands: null,
      depts: null,
      createUser: null,
      updateUser: null
    });

    this.userGroupSubscriptionColumns = this.userGroupSubscriptionTableTranslation();
  }

  userGroupSubscriptionTableTranslation(): any[] {
    var fields: string[];
    var dates: string[];
    var fieldSorts: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = ['notifyEventGroupKey', 'groupCode', 'tenantMappingUserGroupSeqNo', 'tenant', 'orgId', 'workType', 'brand', 'vendorCategory', 'dept', 'consigneeKey', 'salesCode', 'isActivated', 'updateActivatedUser', 'updateActivatedDt', 'createUser', 'createDt', 'updateUser', 'updateDt'];
    dates = ['updateActivatedDt', 'createDt', 'updateDt'];
    fieldSorts = ['notifyEventGroupKey', 'groupCode', 'tenantMappingUserGroupSeqNo', 'tenant', 'orgId', 'workType', 'updateActivatedUser', 'updateActivatedDt', 'createUser', 'createDt', 'updateUser', 'updateDt'];
    jsons = [
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.NotifyEvent',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.GroupCode',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.GroupName',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.Tenant',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.OrgId',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.WorkType',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.Brand',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.VendorCategory',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.Dept',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.Consignee',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.Sales',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.IsActivated',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.UpdateActivatedUser',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.UpdateActivatedDt',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.CreateUser',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.CreateDt',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.UpdateUser',
      'UserGroupSubscriptionMaintenance.Table.HeaderColumns.UpdateDt',
    ];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i]).subscribe((translation: string) => {
        if (dates.includes(fields[i])) {
          tmpcolumn[i] = ({ field: fields[i], header: translation, dataType: 'date', sort: fieldSorts.includes(fields[i]) });
          return;
        }
        tmpcolumn[i] = ({ field: fields[i], header: translation, sort: fieldSorts.includes(fields[i]) })
      });
    }
    console.log("tpmcolumn=", JSON.stringify(tmpcolumn));
    return tmpcolumn;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.editPermission =
      this.userProfile.userType === UserType.SuperAdmin.toString() ||
      this.permissionCodes.includes(this.editPermissionCode);
    if (this.editPermission) {
      this.permissionCode = this.editPermissionCode;
    }

    this.notificationSubScriptionService.getUserGroupSubscriptionNotifyEventOptions().subscribe({
      next: result => {
        this.notifyEventOptions = [...result].map((option: any) => {
          return {
            label: option.text,
            value: option.notifyEventGroupKey,
            workTypeList: option.workTypeList,
          }
        });
        this.notifyEventOptionsBySelectedWorkType = deepCopy(this.notifyEventOptions)?? [];

        this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'WorkType').subscribe({
          next: result => {
            this.workTypeOptions = [...result].map((x: any) => {
              const notifyEventOption = this.notifyEventOptions.find((notifyEventOption: any) => notifyEventOption.workTypeList.includes(x.codeKey));
              return {
                label: x.codeDesc,
                value: x.codeKey,
                notifyEventGroupKey: notifyEventOption.value
              };
            });
            this.searchFormWorkTypeOptionsBySelectedNotifyEvent = deepCopy(this.workTypeOptions)?? [];
            if (!this.dataTable.selectedRow) {
              this.workTypeOptionsBySelectedNotifyEvent = deepCopy(this.workTypeOptions)?? [];
              return;
            }
            this.onRowSelect(this.dataTable.selectedRow);
          }
        });
      }
    });

    this.userGroupSubscriptionMaintenanceService.getTenantMappingUserGroup().subscribe({
      next: (options: any[]) => {
        this.userGroupOptions = options.map(x => ({ value: x.seqNo, label: x.groupName }));
        const tenantByPermission = getTenantByPermission(this.userProfile, this.permissionCode);
        const isAllNull = tenantByPermission.every((x: any) => isNullOrEmpty(x));
        const userGroupOptionsByPermission = options.filter(x => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || tenantByPermission.includes(x.tenant));
        this.userGroupOptionsByPermission = (deepCopy(userGroupOptionsByPermission) as any[]);
        this.searchFormUserGroupOptionsBySelectedTenant = this.userGroupOptionsByPermission.map(x => ({ value: x.seqNo, label: `${x.groupCode} - ${x.groupName}` }));
        this.userGroupOptionsBySelectedTenant = this.userGroupOptionsByPermission.map(x => ({ value: x.seqNo, label: x.groupName }));
      }
    });

    this.notificationSubScriptionService.getTenantOptions().subscribe({
      next: (options: any[]) => {
        this.tenantOptions = options.map(x => ({ value: x.tenantCode, label: `${x.tenantCode} - ${x.tenantName}` }));
        const tenantByPermission = getTenantByPermission(this.userProfile, this.permissionCode);
        const isAllNull = tenantByPermission.every((x: any) => isNullOrEmpty(x));
        const tenantOptionsByPermission = options.filter(x => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || tenantByPermission.includes(x.tenantCode));

        this.tenantOptionsByPermission = (deepCopy(tenantOptionsByPermission) as any[]);
        this.tenantOptionsBySelectedGroup = this.tenantOptionsByPermission.map(x => ({ value: x.tenantCode, label: `${x.tenantCode} - ${x.tenantName}` }));
        this.searchFormTenantOptionsBySelectedGroup = this.tenantOptionsByPermission.map(x => ({ value: x.tenantCode, label: `${x.tenantCode} - ${x.tenantName}` }));


        this.notificationSubScriptionService.getTenantOrgOptions().subscribe({
          next: (options: any[]) => {
            options = options.filter(option => this.tenantOptionsByPermission.findIndex(tenantOption => tenantOption.tenantCode === option.tenantCode) > -1);
            this.orgIdOptions = options.map(x => ({ value: x.orgId, label: `${x.orgId} - ${x.orgName}` }));
            const orgIdByPermission = getOrgIdByPermission(this.userProfile, this.permissionCode);
            const isAllNull = orgIdByPermission.every((x: any) => isNullOrEmpty(x));
            const orgIdOptionsByPermission = options.filter(x => this.userProfile.userType === UserType.SuperAdmin.toString() ||
              isAllNull || orgIdByPermission.includes(x.orgId) || (this.tenantOptionsByPermission && this.tenantOptionsByPermission.findIndex(tenantOption => tenantOption.tenantCode === x.tenantCode) > -1));
            this.orgIdOptionsByPermission = (deepCopy(orgIdOptionsByPermission) as any[]);
            this.orgIdOptionsBySelectedTenant = this.orgIdOptionsByPermission.map(x => ({ value: x.orgId, label: `${x.orgId} - ${x.orgName}` }));
          }
        });
      }
    });

    this.dropdownOptionsService.getBrandOptions(1).subscribe({
      next: (options: any[]) => {
        const brandByPermission = getBrandByPermission(this.userProfile, this.permissionCode);
        const isAllNull = brandByPermission.every((x: any) => isNullOrEmpty(x));
        const brandOptionsByPermission = options.filter(x => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || brandByPermission.includes(x.brandCode));

        this.brandOptions = brandOptionsByPermission.map(x => ({ value: x.brandCode, label: `${x.brandName}` }));
      }
    });

    this.dropdownOptionService.getVendorCategoryOptions().subscribe({
      next: (options: any[]) => {
        this.brandAndVendorCategoryOptions = deepCopy(options)?? [];
        this.vendorCategoryOptions = this.brandAndVendorCategoryOptions.map(x => ({ value: x.vendorCategory, label: x.vendorCategory }));
        this.vendorCategoryOptionsBySelectedBrand = [];
      }
    });

    this.dropdownOptionService.getDeptOptions().subscribe({
      next: (options: any[]) => {
        this.deptOptions = options.map(x => ({ value: x.deptCode, label: `${x.deptCode} - ${x.deptName}`}));
        const deptByPermission = getDeptByPermission(this.userProfile, this.permissionCode);
        const isAllNull = deptByPermission.every((x: any) => isNullOrEmpty(x));
        const deptOptionsByPermission = options.filter(x => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || deptByPermission.includes(x.deptCode));

        this.deptOptionsByPermission = deptOptionsByPermission.map(x => ({ value: x.deptCode, label: `${x.deptCode} - ${x.deptName}` }));
      }
    });

    this.userDataService.getCustomerOptions().then(options => {
      this.customerOptions = options.map((x: any) => ({ value: x.customerCode, label: `${x.customerCode} - ${x.customerName}` }));
      const customerByPermission = getCustomerByPermission(this.userProfile, this.permissionCode);
      const isAllNull = customerByPermission.every((x: any) => isNullOrEmpty(x));
      const customerOptionsByPermission = options.filter((x: any) => this.userProfile.userType === UserType.SuperAdmin.toString() ||
        isAllNull || customerByPermission.includes(x.customerCode));
      this.customerOptionsByPermission = customerOptionsByPermission.map((x: any) => ({ value: x.customerCode, label: `${x.customerCode} - ${x.customerName}` }));
    });

    this.dropdownOptionService.getSalesOptions().subscribe({
      next: (options: any[]) => {
        this.salesOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionService.getUserOptions().subscribe({
      next: (options: any[]) => {
        this.userOptions = options.map(x => ({ label: x.userName, value: x.uuid}));
      }
    });
  }

  showTenantMappingUserGroupDetailDialog(groupCode: any, val: boolean): void {
    this.isShowTenantMappingUserGroupDetail = val;

    if (val) {
      this.tenantMappingUserGroupDetailDialog.getTenantMappingUserGroupDetail(groupCode);
    }
  }

  changeSearchFormWorkTypeOptions(event: any): void {
    const notifyEventOption = this.notifyEventOptions.find(x => x.value === event.value);
    if (notifyEventOption) {
      this.searchFormWorkTypeOptionsBySelectedNotifyEvent = this.filterWorkTypeOptions(notifyEventOption.workTypeList);
      const index = this.searchFormWorkTypeOptionsBySelectedNotifyEvent.findIndex(x => x.value === this.searchForm.value.workType);
      if (index < 0) {
        this.searchForm.controls.workType.setValue(null);
      }
      return;
    }
    this.searchFormWorkTypeOptionsBySelectedNotifyEvent = deepCopy(this.workTypeOptions)?? [];
  }

  changeGroup(event: any, type: string): void {
    let selectedGroupSeqNo = event.value;
    const selectedGroup = this.userGroupOptionsByPermission.find(x => x.seqNo === selectedGroupSeqNo);
    switch (type) {
      case 'searchForm':
        if (selectedGroup) {
          this.searchForm.controls.tenant.setValue(selectedGroup.tenant);
        }
        break;
      case 'table':
        if (this.dataTable.selectedRow) {
          this.dataTable.selectedRow['groupCode'] = selectedGroup.groupCode;
          this.dataTable.selectedRow['tenant'] = selectedGroup.tenant;
          this.changeTenant({ value: selectedGroup.tenant }, 'table');
        }
        break;
    }
  }

  changeTenant(event: any, type: string): void {
    let selectedTenantCode = event.value;
    switch (type) {
      case 'searchForm':
        if (!selectedTenantCode) {
          this.searchFormUserGroupOptionsBySelectedTenant = this.userGroupOptionsByPermission.map(x => ({ value: x.seqNo, label: `${x.groupCode} - ${x.groupName}` }));
          return;
        }
        this.searchFormUserGroupOptionsBySelectedTenant = this.filterUserGroupOptions(selectedTenantCode);
        break;
      case 'table':
        if (!selectedTenantCode) {
          this.userGroupOptionsBySelectedTenant = this.userGroupOptionsByPermission.map(x => ({ value: x.seqNo, label: `${x.groupCode} - ${x.groupName}` }));
          this.orgIdOptionsBySelectedTenant = this.orgIdOptionsByPermission.map(x => ({ value: x.orgId, label: `${x.orgId} - ${x.orgName}` }));
          return;
        }
        this.userGroupOptionsBySelectedTenant = this.filterUserGroupOptions(selectedTenantCode);
        this.orgIdOptionsBySelectedTenant = this.filterOrgOptions(selectedTenantCode);
        break;
    }
  }

  filterUserGroupOptions(selectedTenantCode: any): any[] {
    return this.userGroupOptionsByPermission.filter(option => {
      return selectedTenantCode.includes(option.tenant);
    }).map(option => ({ value: option.seqNo, label: `${option.groupCode} - ${option.groupName}`}));
  }

  filterOrgOptions(selectedTenantCode: any): any[] {
    return this.orgIdOptionsByPermission.filter(option => {
      return option.tenantCode === selectedTenantCode;
    }).map(option => ({ value: option.orgId, label: `${option.orgId} - ${option.orgName}` }));
  }

  updateTenantBySelectedOrg(event: any): void {
    const org = this.orgIdOptionsByPermission.find(x => x.orgId === event.value);
    if (this.dataTable.selectedRow) {
      this.dataTable.selectedRow['tenant'] = org.tenantCode;
      this.changeTenant({value: org.tenantCode}, 'table');
    }
  }

  getWorkTypeOptionsBySelectedNotifyEvent(event: any, rowData: any): void {
    const notifyEventOption = this.notifyEventOptions.find(x => x.value === event.value);
    if (notifyEventOption) {
      this.workTypeOptionsBySelectedNotifyEvent = this.filterWorkTypeOptions(notifyEventOption.workTypeList);
      const index = this.workTypeOptionsBySelectedNotifyEvent.findIndex(x => x.value === rowData.workType);
      if (index < 0) {
        rowData.workType = null;
      }
    }
  }

  filterWorkTypeOptions(workTypeList: any): any[] {
    return this.workTypeOptions.filter(option => {
      return workTypeList.includes(option.value);
    });
  }

  updateNotifyEventBySelectedWorkType(event: any, type: string): void {
    // 1. 依據 workType 取得所有符合的 notifyEvent options
    const matchedOptions = this.notifyEventOptions.filter((x: any) => x.workTypeList && x.workTypeList.includes(event.value));

    switch (type) {
      case 'searchForm': {
        const control = this.searchForm.controls.notifyEventGroupKey;
        const currentValue = control.value;
        if (matchedOptions.length === 0) {
          // 4. 無匹配資料 -> 重設 value
            control.setValue(null);
        } else {
          // 2. 判斷當前值是否仍存在於匹配結果
          const exists = matchedOptions.some(o => o.value === currentValue);
          // 3. 不存在則取第一筆設定，存在則不動作
          if (!exists) {
            control.setValue(matchedOptions[0].value);
          }
        }
        break;
      }
      case 'table': {
        if (!this.dataTable.selectedRow) { return; }
        const currentValue = this.dataTable.selectedRow['notifyEventGroupKey'];
        if (matchedOptions.length === 0) {
          this.dataTable.selectedRow['notifyEventGroupKey'] = null; // 4. 重設
        } else {
          const exists = matchedOptions.some(o => o.value === currentValue);
          if (!exists) {
            this.dataTable.selectedRow['notifyEventGroupKey'] = matchedOptions[0].value; // 3. 取第一筆
            this.getWorkTypeOptionsBySelectedNotifyEvent({ value: matchedOptions[0].value }, this.dataTable.selectedRow);
          }
        }
        break;
      }
    }
  }

  updateVendorCategoryByBrand(event: any): void {
    this.vendorCategoryOptionsBySelectedBrand = [];
    if (event.value.length !== 1 && this.dataTable.selectedRow) {
      this.dataTable.selectedRow['vendorCategory'] = [];
    }
    this.vendorCategoryOptionsBySelectedBrand =
      this.brandAndVendorCategoryOptions
        .filter((x) => x.brand === event.value[0])
        .map((x) => ({ value: x.vendorCategory, label: x.vendorCategory }));
  }

  showEditConsigneeKeyAndSalesCode(rowData: any): any {
    return (this.workTypeOptionsBySelectedNotifyEvent.filter((x: any) => x.value.includes("DELIVERY_ORDER")).length > 0) ||
      (rowData['workType'] && (rowData['workType'] === 'COMMON_DELIVERY_ORDER' || rowData['workType'] === 'TENANT_GROUP_TRANSFER_DELIVERY_ORDER'));
  }

  onRowSelect(event: any): void {
    let resetUserGroupAndOrgIdOptions = event && !event.tenant;
    let resetWorkTypeOptions = event && !event.notifyEventGroupKey;
    let resetVendorCategoryOptions = event && !event.brand;
    if (!event || resetUserGroupAndOrgIdOptions) {
      this.userGroupOptionsBySelectedTenant = this.userGroupOptionsByPermission.map(x => ({ value: x.seqNo, label: `${x.groupCode} - ${x.groupName}` }));
      this.orgIdOptionsBySelectedTenant = this.orgIdOptionsByPermission.map(option => ({ value: option.orgId, label: `${option.orgId} - ${option.orgName}` }));
    }
    if (!event || resetWorkTypeOptions) {
      this.workTypeOptionsBySelectedNotifyEvent = deepCopy(this.workTypeOptions)?? [];
    }
    if (!event || resetVendorCategoryOptions) {
      this.vendorCategoryOptionsBySelectedBrand = [];
    }

    if (event) {
      if (event.tenant) {
        this.changeTenant({ value: event.tenant }, 'table');
      }
      if (event.notifyEventGroupKey) {
        this.getWorkTypeOptionsBySelectedNotifyEvent({ value: event.notifyEventGroupKey }, event);
      }
      if (event.brand) {
        this.updateVendorCategoryByBrand({ value: event.brand });
      }
    }
  }

  dataInputValid(rowData: UserGroupSubscriptionData): boolean {
    if (rowData) {
      if (isNullOrEmpty(rowData.notifyEventGroupKey) || isNullOrEmpty(rowData.tenantMappingUserGroupSeqNo) ||
            isNullOrEmpty(rowData.tenant) || isNullOrEmpty(rowData.orgId) || isNullOrEmpty(rowData.workType)) {
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFields'));
        return false;
      }
    }
    return true;
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchUserGroupSubscription();
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    console.log("subscription-sortOrder=", JSON.stringify(this.sortOrder));
    this.dataTable.setCurrentPage(0);
    this.searchUserGroupSubscription();
  }

  restoreData(): void {
    this.ngOnInit();
  }

  searchBtnClick(): void {
    this.isSearchFormOpen = false;
    this.dataTable.isInEditMode = false;
    this.dataTable.loading = true;
    this.dataTable.setCurrentPage(0);
    this.dataTable.restoreDataEvent();
    this.searchUserGroupSubscription();
  }

  resetBtnClick(): void {
    this.searchFormWorkTypeOptionsBySelectedNotifyEvent = deepCopy(this.workTypeOptions)?? [];
    this.searchFormTenantOptionsBySelectedGroup = this.tenantOptionsByPermission.map(x => ({ value: x.tenantCode, label: `${x.tenantCode} - ${x.tenantName}` }));
    this.searchFormUserGroupOptionsBySelectedTenant = this.userGroupOptionsByPermission.map(x => ({ value: x.seqNo, label: `${x.groupCode} - ${x.groupName}` }));
  }

  searchUserGroupSubscription(): void {
    this.dataTable.loading = true;
    this.dataTable.cancelRowEdit();
    this.dataTable.isInEditMode = false;
    this.dataTable.setCurrentPage(0);

    const request = {
      userDataScopes: getDataScopeByPermission(this.userProfile, PermissionConstants.ViewUserGroupSubscription),
      notifyEventGroupKey: this.searchForm.value.notifyEventGroupKey,
      tenant: this.searchForm.value.tenant,
      tenantMappingUserGroupSeqNo: this.searchForm.value.tenantMappingUserGroupSeqNo,
      workType: this.searchForm.value.workType,
      brands: this.searchForm.value.brands,
      depts: this.searchForm.value.depts,
      createUser: this.searchForm.value.createUser,
      updateUser: this.searchForm.value.updateUser,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    };

    this.userGroupSubscriptionMaintenanceService.searchUserGroupSubscription(request).subscribe({
      next: (response) => {
        if (isNullOrEmpty(response)) {
          this.toastService.error(this.translateService.instant('Common.Toast.GetDataFail'));
          return;
        }

        this.userGroupSubscriptionData = [];

        //Update table
        if (!isNullOrEmpty(response.content)) {
          this.userGroupSubscriptionData = deepCopy(response.content) ?? [];
          this.userGroupSubscriptionData.forEach(x => {
            x.transIsActivated = (x.isActivated === 1);
          });
        }
        this.dataTable.updateTableData(this.userGroupSubscriptionData);

        if (this.dataTable.selectedRow) {
          this.onRowSelect(this.dataTable.selectedRow);
        }

        // Change page Info
        this.pageInfo.totalRecords = response.totalElements;
        this.dataTable.setPageInfo(this.pageInfo.totalRecords);
      },
      error: (response) => {
        this.userGroupSubscriptionData = [];
        this.dataTable.updateTableData(this.userGroupSubscriptionData);

        this.pageInfo.totalRecords = 0;
        this.pageInfo.totalPages = 0;
        this.dataTable.setPageInfo(this.pageInfo.totalRecords);
        this.toastService.error(this.translateService.instant('Common.Toast.GetDataFail') + response.status);
      },
      complete: () => {
        this.dataTable.loading = false;
      }
    })
  }

  createNewRow(rowId: number): any {
    let newRow = {
      seqNo: null,
      notifyEventGroupKey: null,
      groupCode: null,
      tenant: null,
      orgId: null,
      workType: null,
      brand: null,
      vendorCategory: null,
      dept: null,
      consigneeKey: null,
      salesCode: null,
      isActivated: 1,
      rowId: rowId
    };
    return newRow;
  }

  createRow(rowData: any): void {
    this.onRowSelect(rowData);
  }

  saveData(savedDataBean: DataTableSavedBean): void {
    for (let i = 0; i < savedDataBean.newList.length; i++) {
      const rowData = savedDataBean.newList[i];
      if (!this.dataInputValid(rowData)) {
        this.dataTable.table.initRowEdit(rowData);
        this.dataTable.loading = false;
        return;
      }
    }
    for (let i = 0; i < savedDataBean.updatedList.length; i++) {
      const rowData = savedDataBean.updatedList[i];
      if (!this.dataInputValid(rowData)) {
        this.dataTable.table.initRowEdit(rowData);
        this.dataTable.loading = false;
        return;
      }
    }
    const saveDataRequest = {
      insertList: savedDataBean.newList,
      updateList: savedDataBean.updatedList
    };
    this.userGroupSubscriptionMaintenanceService.saveUserGroupSubscription(saveDataRequest).subscribe({
      next: () => {
        this.dataTable.saveSuccessEvent();
        this.searchUserGroupSubscription();
        this.toastService.success(this.translateService.instant('Common.Toast.SaveSuccess'));
      },
      error: async response => {
        this.dataTable.loading = false;
        var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
        var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
        this.toastService.error(msg);
      }
    });
  }

  changeActivated(event: any, rowData: UserGroupSubscriptionData): void {
    if (!rowData.seqNo) {
      rowData['isActivated'] = event.checked === true ? 1 : 0;
      rowData['transIsActivated'] = event.checked;
      return;
    }
    const isActivated: string = event.checked === true ? '1' : '0';
    this.userGroupSubscriptionMaintenanceService.changeUserGroupSubscriptionIsActivated(rowData.seqNo.toString(), isActivated).subscribe({
      next: () => {
        this.dataTable.saveSuccessEvent();
        this.searchUserGroupSubscription();
        this.toastService.success(this.translateService.instant('Common.Toast.SaveSuccess'));
      },
      error: async response => {
        this.dataTable.loading = false;
        var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
        var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
        this.toastService.error(msg);
      }
    });
  }

  exportDataToExcel(): void {
    const request = {
      userDataScopes: getDataScopeByPermission(this.userProfile, PermissionConstants.ViewUserGroupSubscription),
      notifyEventGroupKey: this.searchForm.value.notifyEventGroupKey,
      tenant: this.searchForm.value.tenant,
      tenantMappingUserGroupSeqNo: this.searchForm.value.tenantMappingUserGroupSeqNo,
      workType: this.searchForm.value.workType,
      brands: this.searchForm.value.brands,
      depts: this.searchForm.value.depts,
      createUser: this.searchForm.value.createUser,
      updateUser: this.searchForm.value.updateUser,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    };

    this.userGroupSubscriptionMaintenanceService.getUserGroupSubscriptionExcel(request).subscribe({
      next: (response) => {
        if (isNullOrEmpty(response)) {
          this.toastService.error(this.translateService.instant('Common.Toast.NoFileError'));
          return;
        }

        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        const url = URL.createObjectURL(blob);
        const linkEle = document.createElement('a');
        linkEle.href = url;
        const currentDate = this.datePipe.transform(new Date(), 'yyyyMMdd_HHmmss');
        linkEle.download = `UserGroupSubscription_${currentDate}.xlsx`;
        linkEle.click();
        URL.revokeObjectURL(url);
        linkEle.remove();
      },
      error: async response => {
        var instantMsg = await this.translateService.get("Common.Toast.ExportFail").toPromise();
        var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
        this.toastService.error(msg);
      }
    });
  }

  importDataFromExcel(file: any): void {
    if (!file) {
      return;
    }

    // 讀取 Excel 檔案 先進行重置
    this.isSearchFormOpen = false;
    this.dataTable.loading = true;
    this.dataTable.setCurrentPage(0);
    this.dataTable.restoreDataEvent();
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = xlsx.read(data, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = xlsx.utils.sheet_to_json(worksheet, { defval: '' });
      const filteredData = (jsonData as any[]).filter(item => item.seqNo !== '序號');
      const transToDataTableSavedBean = this.transformDataPipe(filteredData);
      this.userGroupSubscriptionData = transToDataTableSavedBean;
      this.dataTable.first = 0;
      this.dataTable.rows = this.userGroupSubscriptionData.length;
      // 使用 skipBackup 參數,避免匯入資料被同步到 backupValue
      this.dataTable.updateTableData(this.userGroupSubscriptionData, true);
      if (this.dataTable.selectedRow) {
        this.onRowSelect(this.dataTable.selectedRow);
      }
      this.pageInfo.totalRecords = this.userGroupSubscriptionData.length;
      this.dataTable.setPageInfo(this.pageInfo.totalRecords);
      this.dataTable.loading = false;
    };
    reader.readAsArrayBuffer(file);
  }



  templateDownloadBtn(): void{

    var fileType = 'UserGroupSubscriptionTemplate';

    this.commonDataService.getSystemParam(fileType).subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.dOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' });
          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'UserGroupSubscriptionTemplate.xlsx';
          link.click();
        });
      }
    });
  }
}
